export const DATEPICKER_YEARS_NUMBER = 13;

export enum SLIDER_DIRECTION {
  LEFT = 'left',
  RIGHT = 'right'
}

export const DATEPICKER_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const DATEPICKER_WEEKS = `<div class="flatpickr-weekdaycontainer">
      <span class="flatpickr-weekday">Mon</span>
      <span class="flatpickr-weekday">Tue</span>
      <span class="flatpickr-weekday">Wed</span>
      <span class="flatpickr-weekday">Thu</span>
      <span class="flatpickr-weekday">Fri</span>
      <span class="flatpickr-weekday">Sat</span>
      <span class="flatpickr-weekday">Sun</span>
    </div>`;

export const DATEPICKER_MIN_VALUE = '2018, 9, 21';

export enum FilterComponentTypes {
  TaskManagement = 'taskManagement',
  AlertsModal = 'alertsModal',
  Modal = 'modal',
  ProductionTickets = 'productionTickets',
  OrdersDashboard = 'ordersDashboard',
  ArchivedOrdersDashboard = 'archivedOrdersDashboard',
  OrderInfo = 'orderInfo',
  OrdersNew = 'ordersNew',
  ArchivedOrdersNew = 'archivedOrdersNew',
  OrdersNewInfo = 'OrdersNewInfo',
}
